import React from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderTwo from "../common/header/HeaderTwo";
import SEO from "../common/SEO";
import BannerFour from "../component/banner/BannerFour";
import CtaLayoutOne from "../component/cta/CtaLayoutOne";
import FaqOne from "../component/faq/FaqOne";
import ProcessOne from "../component/process/ProcessOne";
import VideoTwo from "../component/video/VideoTwo";
import BlogOne from "../component/blog/BlogOne";
import WhyChooseOne from "../component/whychoose/WhyChooseOne";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import Testimonials from "./Testimonials";
//
const HomeStartup = () => {
  return (
    <>
      <SEO title="Acceuil" />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderTwo />
        <div id="accueil">
          <BannerFour />
        </div>
        <VideoTwo />
        <div id="comment-ca-marche">
          <ProcessOne />
        </div>
        <div id="qui-sont-nos-locataires">
          <WhyChooseOne />
        </div>
        {/* Section Blog réactivée */}
        {/* <div id="blog">
          <BlogOne />
        </div> */}
        <div id="faq">
          <FaqOne />
        </div>
        {/* <Testimonials /> */}
        <div id="estimation">
          <CtaLayoutOne />
        </div>
        <FooterOne />
      </main>
    </>
  );
};

export default HomeStartup;
